const parser = new DOMParser();

const htmlToPlainText = (html: string) => {
    const plainTextHtml = html.replaceAll('</p>', '\n</p>').replaceAll('<li>', '<li>- ');

    return parser.parseFromString(plainTextHtml, 'text/html').body.textContent?.trim() || '';
};

export default htmlToPlainText;
